import { render, staticRenderFns } from "./BartenderShell.vue?vue&type=template&id=219ccf62&"
import script from "./BartenderShell.vue?vue&type=script&lang=ts&"
export * from "./BartenderShell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports